import React from 'react';
import { Space, Text } from '@cashfree-intl/coherent';
import { StyledProgressBar, StyledProgressCircle } from '../styled';

const AttemptBar = ({ interval }) => {
  return (
    <>
      <div className="p-2 mt-2">
        <StyledProgressBar>
          {interval.map((percent, i) => (
            <StyledProgressCircle left={percent} index={i} />
          ))}
        </StyledProgressBar>
      </div>
      <Space justifyContent="space-between" className="mb-4">
        <Text variant="b14" color="bodyLight">
          Attempt 1
        </Text>
        <Text variant="b14" color="bodyLight">
          Attempt {interval.length}
        </Text>
      </Space>
    </>
  );
};

export default AttemptBar;
